module.exports = __webpack_public_path__ + "static/media/camera_yellow_filled.bc3ea4f1.svg";